module.exports = __webpack_public_path__ + "static/media/north-pole.8e46f96f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/north-pole.png
 ** module id = 464
 ** module chunks = 0
 **/